"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Legend = function Legend() {
  return null;
};
Legend.defaultProps = {
  iconType: 'square',
  iconSize: '12',
  layout: 'vertical',
  align: 'right',
  verticalAlign: 'top'
};
var _default = Legend;
exports["default"] = _default;